import bearerAxios from "../helpers/bearerAxios";
import {logger} from "./loggingService";


const getACADExcelFile = async (opId: string, designId: string) => {
    try {
        return bearerAxios
            .post(
                import.meta.env.VITE_BASE_URL +
                import.meta.env.VITE_GET_ACAD_FILE! +
                `?opportunityId=${opId}&designId=${designId}`
            ,null,{
                responseType: 'blob'
                })
            .then((response) => {
                return response.data;
            });
    } catch (error) {
        logger.error(error);
        throw error;
    }
};


export {getACADExcelFile};